export const getErrorMessage = (error: unknown): string | undefined => {
  const notNullishObjWithProp = (obj: unknown, prop: string): obj is Record<string, unknown> => {
    return obj !== null && typeof obj === "object" && prop in obj;
  };

  if (
    notNullishObjWithProp(error, "response") &&
    notNullishObjWithProp(error.response, "errors") &&
    Array.isArray(error.response.errors)
  ) {
    return error.response.errors[0]?.message;
  }

  if (notNullishObjWithProp(error, "message") && typeof error.message === "string") {
    return error.message;
  }
  return undefined;
};
